import { useAlertContext } from "src/components/AlertContext";
import { useController } from "src/hooks/useController";
import {
  UwConfigHistoryEndpoint,
  UwConfigOptionsEndpoint,
  UwConfigRowsEndpoint,
  UwConfigType,
} from "./UwConfigEndpoints";

/**
 * After a successful write: confirm it, then reload what it can change: the config's rows, its dropdown options (e.g. a
 * newly added metro) and the history (refetched next time the History tab is shown).
 *
 * Never throws: the write already succeeded, so a failed reload must not look like a failed save (and invite a retry).
 */
export function useAfterUwConfigWrite() {
  const { fetch, invalidate } = useController();
  const { showSuccess, showWarning } = useAlertContext();
  return async (configType: UwConfigType, successMessage: string) => {
    showSuccess(successMessage);
    const results = await Promise.allSettled([
      fetch(UwConfigRowsEndpoint, { configType }),
      fetch(UwConfigOptionsEndpoint, { configType }),
      invalidate(UwConfigHistoryEndpoint, {}),
    ]);
    if (results.some((r) => r.status === "rejected")) {
      showWarning("Saved, but the page couldn't refresh. Reload to see the latest values.");
    }
  };
}
